import service from '@/api/service/service';
import qs from "qs";

export function stuInfo(data = {}) {
  return service({
    url: "/api/organization/view_student_info.json",
    method: 'post',
    data: qs.stringify(data),
  });
}
export function uploadSchedule(data = {}) {
  return service({
    url: "/api/organization/update_timetable.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

// 讲师测评培训班列表
export function getEvaluatList(data = {}) {
  return service({
    url: '/api/evaluation/teacher_eva_class.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 查看测评详情
export function getEvaluations(params = {}) {
  return service({
    url: '/api/evaluation/tea_view_eva.json',
    method: 'get',
    params,
  })
}

// 获取需要测评的机构
export function getTeaRatingInfo(params = {}) {
  return service({
    url: '/api/evaluation/tea_evaluation_data.json',
    method: 'get',
    params,
  })
}

// 保存讲师评价机构的结果
export function saveTeaEvaluat(data = {}) {
  return service({
    url: '/api/evaluation/tea_evaluation_save.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 获取成绩学生信息
export function getScoreInfo(data = {}) {
  return service({
    url: '/api/organization/score_add_student_data.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 获取成绩学生信息 - 提交五人制学员成绩报告
export function getFiveScoreInfo(params = {}) {
  return service({
    url: '/api/organization/student_achievement_file_info.json',
    method: 'get',
    params,
  })
}

// 提交五人制学员成绩报告
export function postFiveStuScoreDoc(data = {}) {
  return service({
    url: '/api/organization/student_achievement_file_save.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 上传成绩
export function uploadScore(data = {}) {
  return service({
    url: '/api/organization/score_add_save.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 成绩报告
export function getReportInfo(params = {}) {
  return service({
    url: '/api/organization/class_report_info.json',
    method: 'get',
    params,
  })
}
// 助理讲师评价表
export function promote_record_data(params = {}) {
  return service({
    url: '/api/organization/promote_record_data.json',
    method: 'get',
    params,
  })
}
// 保存助理讲师评价表
export function promote_record_data_save(data = {}) {
  return service({
    url: '/api/organization/promote_record_data_save.json',
    method: 'post',
    data:qs.stringify(data),
  })
}
// 得到模板课题
export function promote_template_data(data = {}) {
  return service({
    url: '/api/organization/promote_template_data.json',
    method: 'post',
    data:qs.stringify(data),
  })
}

// 获取总体评价建议
export function promote_advice_data(data = {}) {
  return service({
    url: '/api/organization/promote_advice_data.json',
    method: 'post',
    data:qs.stringify(data),
  })
}
// 保存总体评价建议
export function promote_advice_data_save(data = {}) {
  return service({
    url: '/api/organization/promote_advice_data_save.json',
    method: 'post',
    data:qs.stringify(data),
  })
}

// 上传讲师评价文件
export function uploadTeaEva(params = {}) {
  return service({
    url: '/api/organization/upload_teacher_eva.json',
    method: 'get',
    params,
  })
}

// 培训班报告数据
export function uploadReport(data = {}) {
  return service({
    url: '/api/organization/class_report_save.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 培训班报告数据 助理讲师填写
export function uploadReportAssistant(data = {}) {
  return service({
    url: '/api/organization/class_report_save_assistant.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 获取下载教案的数量
export function downloadNum(data = {}) {
  return service({
    url: '/api/plan/pdf_download_batch_num.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 获取教师个人信息详情
export function teacher_sign_info_view(params = {}) {
  return service({
    url: '/api/main/teacher_sign_info_view.json ',
    method: 'get',
    params,
  })
}

// 获取教师是否是第一次登录详情
export function teacher_info_check(params = {}) {
  return service({
    url: '/api/main/teacher_info_check.json ',
    method: 'get',
    params,
  })
}

// 晋升经历获取
export function teacher_promote_list(data = {}) {
  return service({
    url: '/api/organization/teacher_promote_list.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

//获取实践，理论主题列表
export function promote_subject_view(data = {}) {
  return service({
    url: '/api/organization/promote_subject_view.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 保存选择的实践课和理论课主题
export function promote_subject_save(data = {}) {
  return service({
    url: '/api/organization/promote_subject_save.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

//下载助理讲师评级表
export function teacher_promote_down(params = {}) {
  return service({
    url: '/api/organization/teacher_promote_down.json',
    method: 'get',
    params,
  })
}

//讲师注册列表
export function teacherAssociation(params = {}) {
  return service({
    url: '/api/user/teacherAssociation.json',
    method: 'get',
    params,
  })
}

// 讲师获取所有学员列表
export function getStuListByClass(params) {
  return service({
    url: '/api/main/class_student_info_view.json',
    method: 'GET',
    params
  })
}

// 讲师简历 信息返回
export function getTeacherResumeInfo(params = {}) {
  return service({
    url: '/api/user/teacher_resume_info.json',
    method: 'get',
    params,
  })
}
// 讲师简历 信息返回
export function teacherResumeSave(data = {}) {
  return service({
    url: '/api/user/teacher_resume_save.json',
    method: 'post',
    data: qs.stringify(data),
  })
}
